
const LocalStorageConstant: any = {
    accessToken: "access-token",
    refreshToken: "refresh-token",
    user: "user",
    selectedCustomer: "customer-selected"
};

export default LocalStorageConstant;